import { apiClient } from './apiClient'

/**
 * DD-1346/DD-1352/DD-1353 — resumen de último acceso e historial de intentos del usuario
 * autenticado. Consume GET /api/auth/last-access y /api/auth/access-history (server/src/routes/auth.ts).
 */
export interface LastAccess {
  previousLoginAt: number | null
  previousLoginIp: string | null
  previousLoginSource: string | null
  failedAttemptsSinceLastAccess: number
  lastFailedAttemptAt: number | null
}

export interface AccessHistoryRow {
  createdAt: string
  action: string
  result: 'success' | 'failure'
  ipAddress: string | null
  userAgent: string | null
}

export interface TwoFactorSetupEmailResult {
  success: true
  method: 'email'
}

export interface TwoFactorSetupTotpResult {
  success: true
  secret: string
  qrCode: string
  manualEntryKey: string
}

export const myAccountService = {
  async getLastAccess(): Promise<LastAccess> {
    const response = await apiClient.get('/auth/last-access')
    return response.data.data
  },

  async getAccessHistory(limit = 20): Promise<AccessHistoryRow[]> {
    const response = await apiClient.get('/auth/access-history', { limit })
    return response.data.data
  },

  // DD-1346/DD-1353 — enrolamiento propio de 2FA, espejo del que ya existe en vue-frontend. Como
  // el 2FA vive en la misma tabla `user` que el producto, esto habilita/desactiva el mismo 2FA
  // que ya usa el login del producto.
  async setup2FAEmail(): Promise<TwoFactorSetupEmailResult> {
    const response = await apiClient.post('/auth/2fa/setup', { method: 'email' })
    return response.data
  },

  async setup2FATotp(): Promise<TwoFactorSetupTotpResult> {
    const response = await apiClient.post('/auth/2fa/setup', { method: 'totp' })
    return response.data
  },

  async verify2FATotp(code: string): Promise<void> {
    await apiClient.post('/auth/2fa/verify', { code })
  },

  async disable2FA(code: string | null = null): Promise<void> {
    await apiClient.post('/auth/2fa/disable', code ? { code } : {})
  },
}
